<template lang="pug">

  div.container

    .half-width.margin-auto
      h3.title Ingrese sus credenciales

      .field
        p.control.has-icons-left.has-icons-right
          input.input(type='text', placeholder='DNI', v-model="username", @keyup.enter="login")
          span.icon.is-small.is-left
            i.fa.fa-user
      .field
        p.control.has-icons-left
          input.input(type='password', placeholder='Password', v-model="password", @keyup.enter="login")
          span.icon.is-small.is-left
            i.fa.fa-lock

      router-link.link(to="/forgot-password-request") ¿Olvidaste tu contraseña?

      .field
        p.control.has-text-centered
          button.button.is-primary(@click="login", :class="{'is-loading': isLoading}") Ingresar


      transition(name="fade")
        article.message.is-danger(v-if="errorMessage")
          .message-body
            strong {{errorMessage}}

</template>

<script>
// import data from '../util/data'
import { apiPost } from '../util/general'
export default {
  name: 'login',
  data () {
    return {
      username: '',
      password: '',
      errorMessage: '',
      isLoading: false
    }
  },
  methods: {
    login () {
      var vm            = this
      this.isLoading    = true
      this.errorMessage = ''

      var obj = {
        username: this.username,
        password: this.password
      }

      apiPost(vm, '/login', obj, function (data) {
        localStorage.setItem('token', data.token)
        localStorage.setItem('codigo', data.codigo)
        localStorage.setItem('email', data.email)
        localStorage.setItem('perfilVacaciones', data.perfilVacaciones)
        localStorage.setItem('nombre', data.nombre)
        localStorage.setItem('username', data.username)
        localStorage.setItem('nacimiento', data.nacimiento)
        localStorage.setItem('tokenOctopus', data.tokenOctopus)
        window.location.reload(true)
      }, function (error) {
        vm.errorMessage = error.message
        vm.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .link
    display inline-block
    margin-bottom 10px
    color #565cde
</style>



// WEBPACK FOOTER //
// Login_View.vue?de5ace9e